import { Marker } from "../types/marker";

export const getNextMarker = (currentTime: number, markers: Marker[]) => {
  return (
    markers.find(({ time }) => time > currentTime) ??
    markers[markers.length - 1]
  );
};

export const getCurrentMarker = (currentTime: number, markers: Marker[]) => {
  const reversedMarkers = [...markers].reverse();

  return reversedMarkers.find(({ time }) => time <= currentTime) ?? markers[0];
};

export const getPrevMarker = (currentTime: number, markers: Marker[]) => {
  const currentMarker = getCurrentMarker(currentTime, markers);
  const reversedMarkers = [...markers].reverse();

  return (
    reversedMarkers.find(({ time }) => time < currentMarker.time) ?? markers[0]
  );
};
